import { z } from 'zod'

/**
 * Schéma pour valider les données d'un grain d'apprentissage
 */
export const LearningGrainSchema = z.object({
  learningGrainId: z.number(),
  learningGrainTitle: z.string(),
  learningGrainOrder: z.number(),
  postQuizVersionNumber: z.number().nullable(),
  postQuizScoreScaled: z.number().nullable(),
  postQuizScoreScaledHistory: z.array(z.number()),
  postQuizCountAttempt: z.number(),
  postQuizEvalRangeName: z.string().nullable()
})

/**
 * Schéma pour valider les données d'un score d'étudiant
 */
export const StudentScoreSchema = z.object({
  identifier: z.string(),
  firstname: z.string(),
  lastname: z.string(),
  teacherFirstname: z.string().nullable(),
  teacherLastname: z.string().nullable(),
  taskId: z.number(),
  taskTitle: z.string(),
  taskOrder: z.number(),
  learningModuleId: z.number(),
  learningModuleTitle: z.string(),
  learningModuleOrder: z.number(),
  displayOrder: z.number(),
  diagVersionNumber: z.number().nullable(),
  diagScorePercentRounded: z.number().nullable(),
  diagEvalRangeName: z.string().nullable(),
  moduleScorePercentRounded: z.number().nullable(),
  moduleEvalRangeName: z.string().nullable(),
  diagnosticModuleVariation: z.number().nullable(),
  diagEndVersionNumber: z.number().nullable(),
  diagEndScorePercentRounded: z.number().nullable(),
  diagEndEvalRangeName: z.string().nullable(),
  learningGrains: z.array(LearningGrainSchema)
})

export const StudentScoreArraySchema = z.array(StudentScoreSchema)

/**
 * Schéma pour valider les données d'un module de classe
 */
export const ClassroomModuleResultSchema = z.object({
  learningCourseId: z.number(),
  learningModuleId: z.number(),
  learningModuleTitle: z.string(),
  learningModuleOrder: z.number(),
  displayOrder: z.number(),
  visible: z.boolean(),
  scores: z.array(StudentScoreSchema)
})

/**
 * Schéma pour valider un tableau de résultats de modules
 */
export const ClassroomResultsArraySchema = z.array(ClassroomModuleResultSchema)

export type LearningGrainEntity = z.infer<typeof LearningGrainSchema>
export type StudentScoreEntity = z.infer<typeof StudentScoreSchema>
export type ClassroomModuleResultEntity = z.infer<typeof ClassroomModuleResultSchema>
export type ClassroomResultsArrayEntity = z.infer<typeof ClassroomResultsArraySchema>
